export { NOTIFICATIONS, PROFILE } from '@porotutu/react/api'

export const AUDIT = ['audit'] as const

export const CAMPAIGNS = ['campaigns'] as const

export const CUSTOMERS = ['customers'] as const

export const DASHBOARD = ['dashboard'] as const

export const EARNING_RULES = ['earning-rules'] as const

export const EVENTS = ['events'] as const

export const JOBS = ['jobs'] as const

export const NOTIFICATION_PREFERENCES = ['notification-preferences'] as const

export const ORDERS = ['orders'] as const

export const ORGANIZATIONS = ['organizations'] as const

export const POINT_TRANSACTIONS = ['point-transactions'] as const

export const PRODUCTS = ['products'] as const

export const REDEMPTIONS = ['redemptions'] as const

export const REWARDS = ['rewards'] as const

export const SEGMENTS = ['segments'] as const

export const USERS = ['users'] as const

export const VALIDATION_RULES = ['validation-rules'] as const

export const VOUCHERS = ['vouchers'] as const

export const WEBHOOK_SUBSCRIPTIONS = ['webhook-subscriptions'] as const
